import React, { useState } from "react";
import { Box, Tabs, Tab } from "@material-ui/core";
import AgeProofs from "./AgeProofs";
import AllUsers from "./AllUsers";
import AllViewers from "./AllViewers";
import PlatformKPIMetrics from "./PlatformKPIMetrics";
import styles from "./AgeProofsStyles";

const AdminDashboard = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const classes = styles();

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabIndex(newValue);
  };

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        flexShrink={0}
        marginRight={3}
        marginTop="20px"
        padding="0 16px"
        justifyContent={"center"}
      >
        <Box className={classes.tabWrapper}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            aria-label="admin dashboard tabs"
            TabIndicatorProps={{ style: { display: "none" } }}
          >
            <Tab
              label="Age Proofs"
              className={`${classes.tab} ${
                tabIndex === 0 ? classes.activeTab : ""
              }`}
            />
            <Tab
              label="All Creators"
              className={`${classes.tab} ${
                tabIndex === 1 ? classes.activeTab : ""
              }`}
            />
            <Tab
              label="All viewers"
              className={`${classes.tab} ${
                tabIndex === 2 ? classes.activeTab : ""
              }`}
            />
            <Tab
              label="Platform KPI Metrics"
              className={`${classes.tab} ${
                tabIndex === 3 ? classes.activeTab : ""
              }`}
            />
          </Tabs>
        </Box>
      </Box>
      <Box mt={2}>
        {tabIndex === 0 && <AgeProofs />}
        {tabIndex === 1 && <AllUsers />}
        {tabIndex === 2 && <AllViewers />}
        {tabIndex === 3 && <PlatformKPIMetrics />}
      </Box>
    </Box>
  );
};

export default AdminDashboard;
